import { SET_FILTERS, CLEAR_FILTERS } from '@/store/mutation-types'
const state = {}

const getters = {
  filters: (state) => (routePath) => state[routePath]
}

const mutations = {
  [SET_FILTERS] (state, { routePath, filters }) {
    state[routePath] = filters
  },
  [CLEAR_FILTERS] (state, routePath) {
    delete state[routePath]
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
